import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';
import {Locale} from '../../model/locale';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LocaliService {

  // eslint-disable-next-line @typescript-eslint/naming-convention
  private static LOCALI_REF = 'locali';

  locali$: BehaviorSubject<Locale[]>;
  localeSelected$: BehaviorSubject<Locale>;

  siteContent: any;

  private _jsonURL = '../../assets/site-content.json';

  constructor(
    private _afs: AngularFirestore,
    private httpClient: HttpClient
  ) {

    this.localeSelected$ = new BehaviorSubject<Locale>(null);
    this.locali$ = new BehaviorSubject<Locale[]>([]);

    this.getJSON().subscribe(data => {
      this.siteContent = data;
    });
  }

  get isNaki() {
    return this.localeSelected$?.value?.id === 'naki';
  }

  get isClubHouse() {
    return this.localeSelected$?.value?.id === 'club-house';
  }

  get isLoStecco() {
    return this.localeSelected$?.value?.id === 'lo-stecco';
  }

  get isBoccio() {
    return this.localeSelected$?.value?.id === 'boccio';
  }

  getLocaleById(id: string): Locale {
    return this.locali$?.value?.find(l => l.id === id);
  }

  setLocaleSelected(locale: Locale) {
    this.localeSelected$.next(locale);
  }

  getLocali(): Observable<Locale[]> {
    return this._afs.collection<Locale>(LocaliService.LOCALI_REF).valueChanges();
  }

  private getJSON(): Observable<any> {
    return this.httpClient.get(this._jsonURL);
  }


}
